import styled, { keyframes } from 'styled-components';
import CTA from '../../../../new-components/ui/CTA';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { CTATypes, EntityTypes } from '../../../../new-lib/constants/common';
import { MapMode } from '../../types';
import WhatsappIcon from '../../../../new-components/svg-icons/WhatsappIcon';
import { useRouter } from 'next/router';
import WhatsappBuilder from '../../../../helpers/whatsapp/whatsapp-builder';
import { useTranslation } from 'next-i18next';
import { CompoundsApis } from '../../../../new-lib/apis/compounds.apis';

const DrawerCTA = () => {
  const { locale } = useRouter();

  const selectedCompound = useSelector(
    (state: any) => state.map.selectedCompound
  );

  const mapMode = useSelector((state: any) => state.map.mapMode);

  const { data: compound } = useQuery({
    queryKey: ['compound', selectedCompound, locale],
    queryFn: () => CompoundsApis.getCompound(selectedCompound.id, null, locale),
    enabled: selectedCompound !== null
  });

  return (
    <DrawerContainer mapMode={mapMode} locale={locale}>
      <CTA
        fillContainer={true}
        entity={mapMode === MapMode.COMPOUND ? compound : {}}
        entityType={
          mapMode === MapMode.SEARCH ? EntityTypes.SAHEL : EntityTypes.COMPOUND
        }
      />
    </DrawerContainer>
  );
};

const FloatingCTA = () => {
  const { t } = useTranslation('map');

  const isMobile = useSelector((state: any) => state.app.isMobile);

  const { asPath, locale } = useRouter();
  const referer = useSelector((state: any) => state.app.referer);
  const userId = useSelector((state: any) => state.app.userId);
  const eventId = useSelector((state: any) => state.app.eventId);

  const whatsapp = new WhatsappBuilder(
    {},
    asPath,
    referer,
    userId,
    eventId,
    CTATypes.SAHEL,
    locale
  );

  const handleClick = () => {
    whatsapp.launchWhatsApp();
  };

  return (
    <FloatingContainer onClick={handleClick} locale={locale}>
      <WhatsappIcon fill={isMobile ? '#fff' : '#4CD964'} />

      <span>
        {isMobile ? t('contact_nawy_experts') : t('connect_with_nawy_experts')}
      </span>
    </FloatingContainer>
  );
};

const CallToAction = () => {
  const drawerOpen = useSelector((state: any) => state.map.drawerOpen);

  return drawerOpen ? <DrawerCTA /> : null;
  // :  <FloatingCTA />;
};

const slideInLTR = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;

const slideInRTL = keyframes`
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
`;

const DrawerContainer = styled.div<{
  mapMode: MapMode;
  locale: string | undefined;
}>`
  width: ${props => (props.mapMode === 'search' ? '358px' : '450px')};
  position: fixed;
  bottom: 0;
  inset-inline-end: 0;
  z-index: 999;
  background-color: #fff;
  padding: 16px;
  animation: ${props => (props.locale === 'ar' ? slideInRTL : slideInLTR)} 0.5s
    ease-in;

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    width: 100%;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 99999999;
  }
`;

const FloatingContainer = styled.div<{
  locale: string | undefined;
}>`
  height: 40px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 24px;
  border-radius: 360px;
  background-color: #fff;
  box-shadow:
    0px 0px 4px 0px rgba(0, 0, 0, 0.04),
    0px 4px 8px 0px rgba(0, 0, 0, 0.06);
  cursor: pointer;

  span {
    color: #4cd964;
    font-size: 15px;
    font-family: materialMedium;
    white-space: nowrap;
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    position: fixed;
    top: unset;
    bottom: 24px;
    height: 40px;
    background: #4cd964;
    padding: 16px;
    gap: 4px;
    inset-inline-start: 50%;
    transform: ${props =>
      props.locale === 'ar' ? 'translateX(50%)' : 'translateX(-50%)'};

    span {
      color: #fff;
      font-size: 14px;
    }
  }
`;

export default CallToAction;
